import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { EventEmitterBaseService } from '../core/services/event-emitter-service/event-emitter.service';
import { AppEvents } from '../core/types/app-events';
import { CognitoService } from '../core/services/cognito/cognito.service';
import { SessionService } from '../core/services/session/session.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private session: SessionService, private cognito: CognitoService) {}

  public async canActivate(route?: ActivatedRouteSnapshot, state?: RouterStateSnapshot): Promise<boolean> {
    if (this.cognito.usuarioLogado()) {
      const cognitoTokenValido = await this.cognito.refreshTokenValido();
      if (cognitoTokenValido) {
        await this.cognito.atualizarSessaoCognito();
        EventEmitterBaseService.get(AppEvents.displayApplicationNavigationBars).emit();
        return true;
      }
    }

    this.session.logout();
    await this.cognito.deslogar();
    this.router.navigate(['/login']).catch((error) => console.log(error));
    return false;
  }
}
